import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Stats/Stats'));

export default Loadable;
